// Data-residency region field for forms that read their values from FormData.
//
// With one configured region there is no choice to make, so the field is a hidden input carrying
// that region's id (the form still submits it). Otherwise it is the labelled, required select of
// the configured regions. With no regions loaded yet the empty select stays, so a required field
// still blocks submission instead of sending no region.

import React from 'react';
import { defaultRegionId } from '../../utils/regions';

const RegionField = ({
  regions,
  name = 'regionId',
  defaultValue,
  label = 'Data Residency Region',
  className = 'mb-4',
  labelClassName = 'block text-sm font-medium text-content-secondary mb-1',
}) => {
  const list = regions ?? [];
  const initial = defaultRegionId(list, defaultValue);

  if (list.length === 1) {
    return <input type="hidden" name={name} value={initial} />;
  }

  return (
    <div className={className}>
      <label htmlFor={`${name}-select`} className={labelClassName}>
        {label} <span className="text-red-500">*</span>
      </label>
      <select
        // Remount when the default changes (regions arriving after the form opened), because
        // an uncontrolled select only reads defaultValue on mount.
        key={initial}
        id={`${name}-select`}
        name={name}
        defaultValue={initial}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        required
      >
        <option value="">-- Select Region --</option>
        {list.map((r) => (
          <option key={r.regionId} value={r.regionId}>
            {r.regionName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RegionField;
